import { Redirect } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';

import { useSession } from '@/lib/auth/session';

export default function Index() {
  const { data: session, isPending } = useSession();

  if (isPending) {
    return (
      <View className="min-h-full flex-1 items-center justify-center bg-surface">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (session) {
    return <Redirect href="/app" />;
  }

  return <Redirect href="/login" />;
}
